/**
 * Keyboard contract for the admin search palette, kept in one place so the hint
 * printed on the button and the listener that opens it can never disagree.
 */

/** Mac reads ⌘K; everything else reads Ctrl K. */
export const isAppleLikePlatform = (platform: string, userAgent = ''): boolean =>
  /mac|iphone|ipad|ipod/i.test(platform || userAgent);

export const searchShortcutLabel = (isAppleLike: boolean): string =>
  isAppleLike ? '⌘K' : 'Ctrl K';

export const currentSearchShortcutLabel = (): string => {
  if (typeof navigator === 'undefined') return searchShortcutLabel(true);
  return searchShortcutLabel(isAppleLikePlatform(navigator.platform, navigator.userAgent));
};

/**
 * Accepts both Cmd+K and Ctrl+K everywhere rather than branching on platform — a
 * Mac user with a PC keyboard habit gets the same door. Alt is excluded so we do
 * not swallow other combinations.
 */
export const matchesSearchShortcut = (event: {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
}): boolean => (event.metaKey || event.ctrlKey) && !event.altKey && event.key.toLowerCase() === 'k';
